var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFileImg4({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.6602 28.847V25.5137H23.9935V28.847H20.6602ZM23.9935 22.1803V18.847H20.6602V22.1803H23.9935ZM23.9935 15.5137V12.1803H20.6602V15.5137H23.9935ZM17.3268 18.847H20.6602V15.5137H17.3268V18.847ZM17.3268 25.5137H20.6602V22.1803H17.3268V25.5137ZM35.6602 8.84701V32.1803C35.6602 34.0137 34.1602 35.5137 32.3268 35.5137H8.99349C7.16016 35.5137 5.66016 34.0137 5.66016 32.1803V8.84701C5.66016 7.01367 7.16016 5.51367 8.99349 5.51367H32.3268C34.1602 5.51367 35.6602 7.01367 35.6602 8.84701ZM32.3268 8.84701H20.6602V12.1803H17.3268V8.84701H8.99349V32.1803H32.3268V8.84701Z",
    fill: "#595959"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileImg4);
export default __webpack_public_path__ + "static/media/fileImg4.daae295bdab2bb65fd42779ec49cafa1.svg";
export { ForwardRef as ReactComponent };